export const SHOPPING_AIDS_ITEM = [
  {
    item: 'Simona',
    itemImageDesktop: "/images/listItem/shoppingAids/mirror/Desktop/700x700px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-01.webp",
    itemImageMobile: '/images/listItem/shoppingAids/mirror/Mobile/335x335px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-01.webp',
     path: '/packaging/shopping-aids/mirror/simona',
  },
]